import {
  ModelFilter,
  UndisplayableGroup,
} from '@volkswagen-onehub/car-technical-details-bff';

import {Inspector} from '@volkswagen-onehub/inspect-fa-service';
import * as React from 'react';
import {UndisplaybleGroupInformation} from './UndisplayableGroupInformation';
import {HeaderInformation} from './HeaderInformation';
import styled from 'styled-components';

const StyledTableHeightWrapper = styled.div`
  div[class^='StyledOuterTableWrapper-'] {
    height: auto !important;
  }
  div[class^='StyledTableWrapper-'] {
    height: auto !important;
  }
`;

export const inspector: Inspector = {
  renderContent: () => {
    return (
      <StyledTableHeightWrapper>
        <HeaderInformation inspectDataHolder={inspectDataHolder} />
        <UndisplaybleGroupInformation
          undisplayableGroup={inspectDataHolder.undisplayableGroup}
        />
      </StyledTableHeightWrapper>
    );
  },
};

export interface InspectionData {
  modelsFromContent?: ModelFilter[];
  modelsFromResponse?: ModelFilter[];
  showroomNodeIdFromService?: string;
  showroomNodeIdFromContent?: string;
  undisplayableGroup?: UndisplayableGroup;
}

export const inspectDataHolder: InspectionData = {};
